import { Injectable, inject } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";
import { PropertyMetadata, RegexFormattingOptions } from "@tylertech/tyler-api-types";
import { MetadataPropertyService } from "./metadataPropertyService";

@Injectable({ providedIn: "root" })
export class MetadataInputFormatterService
{
    private $metadataPropertyService = inject(MetadataPropertyService);


    ApplyFormatting(propertyMetadata: PropertyMetadata, model: any, metadataModel: any, parent: any): any
    {
        const options = this.$metadataPropertyService.getRegexFormatter(propertyMetadata, metadataModel, parent);
        if (!Utilities.IsNullOrUndefinedOrEmptyObject(options))
            model = this.GetFormattedValueModel(model, options);
        return model;
    }

    GetFormattedModel(valueModel: string, regexOptions: RegexFormattingOptions): string
    {
        return this.GetFormattedImpl(valueModel, regexOptions.UserInputRegex, regexOptions.BackEndValueRegexReplace);
    }

    GetFormattedValueModel(valueModel: string, regexOptions: RegexFormattingOptions): string
    {
        return this.GetFormattedImpl(valueModel, regexOptions.UserInputRegex, regexOptions.UserDisplayRegexReplace);
    }

    GetFormattedImpl(valueModel: string, userInputRegex: string, displayRegex: string): string
    {
        if (Utilities.IsNullOrUndefinedOrEmpty(valueModel)) return valueModel;

        function replacer(match: string, p1: string, p2: string, p3: string, p4: string, p5: string, p6: string, p7: string, p8: string, p9: string, p10: string, offset: any, s: any): string
        {
            let ret = displayRegex;
            let lastIndex = 0;
            const array = [p1, p2, p3, p4, p5, p6, p7, p8, p9, p10];
            for (let index = 1; index <= array.length; index++)
            {
                const element = array[index - 1];
                if (element === undefined || element === null)
                    break;
                if (element)
                {
                    const newIndex = ret.indexOf("$" + index);
                    if (newIndex > -1)
                        lastIndex = newIndex + 2;
                }
            }
            ret = ret.substring(0, lastIndex);
            for (let index = 1; index <= array.length; index++)
            {
                const element = array[index - 1];
                if (element === undefined || element === null)
                    break;
                if (element)
                    ret = ret.replace("$" + index, element);
            }
            return ret;
        }
        return valueModel.replace(new RegExp(userInputRegex), replacer);
    }

    stringToPhone(str: string, allowExtension: boolean): string
    {
        const inputLen = allowExtension ? 20 : 10;
        const input = str.replace(/\D/g, "")
            .substring(0, inputLen);
        const areaCode = input.substring(0, 3);
        const middle = input.substring(3, 6);
        const last = input.substring(6, 10);
        const ext = allowExtension ? input.substring(10, 20) : "";
        if (allowExtension && input.length > 10)
        {
            str = `(${areaCode}) ${middle}-${last} x${ext}`;
        }
        else if (input.length > 6)
        {
            str = `(${areaCode}) ${middle}-${last}`;
        }
        else if (input.length > 3)
        {
            str = `(${areaCode}) ${middle}`;
        }
        else if (input.length > 0)
        {
            str = `(${areaCode}`;
        }
        return str;
    }
}
